//Assets
import KasaImg from './ProjectImg/KasaImg.PNG'

//Portfolios table
const PortItem = [
  {
    id: '1',
    title: 'Kasa.fr',
    img: `${KasaImg}`,
    imgAlt: 'Accueil du site Kasa.fr',
    url: 'https://mascarotony.github.io/Kasa.fr',
    desc:
      "Site d'agence immobilière développé dans le cadre de l'examen finale de ma formation Open Classrooms."
  }
]

export default PortItem
